import { message } from 'antd'

const MessageInfo = (param) => {
  const key = Date.now()
  const isObject = param && typeof param === 'object' && !Array.isArray(param)
  const type = (isObject ? param.type : null) || 'remind'
  const duration = (isObject ? param.duration : null) || 3
  const src =
    type === 'success'
      ? '/image/success.svg'
      : type === 'error'
        ? '/image/error.svg'
        : type === 'warn'
          ? '/image/warn.svg'
          : '/image/remind.svg'
  const text = isObject ? param.content ?? '' : param

  const content = (
    <div className='max-w-[340px] w-full flex items-center gap-x-[12px]'>
      {/* 原生 img：message 在 portal 里，Next/Image 偶发不渲染导致用户看不到提示 */}
      <img src={src} alt='' width={24} height={24} />
      <span className='text-[14px] leading-[22px] text-[#484B60]'>{text}</span>
    </div>
  )

  message.open({
    content,
    key,
    duration
  })
}

export { MessageInfo }
